/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';

interface ISwitchButton {
    className?: string
    onActiveChange: (activeSide: SwitchButtonState) => void,
    labelLeft: string,
    labelMiddle?: string,
    labelRight: string,
    enableMiddleButton?: boolean,
    size?: 'sm' | 'md' | 'lg',
    active?: SwitchButtonState
}

export enum SwitchButtonState {
    LEFT,
    MIDDLE,
    RIGHT
}

export function SwitchButton(props: ISwitchButton) {
    const [activeButton, setActiveButton]: [SwitchButtonState, any] = useState(props.active ?? SwitchButtonState.LEFT);

    const labelLeft = props.labelLeft;
    const labelMiddle = props.labelMiddle;
    const labelRight = props.labelRight;
    const size = props.size ? props.size : 'md';
    const enableMiddleButton = props.enableMiddleButton ? props.enableMiddleButton : false;

    const leftButtonClicked = () => {
        btnClicked(SwitchButtonState.LEFT)
    };
    const middleButtonClicked = () => {
        btnClicked(SwitchButtonState.MIDDLE)
    }
    const rightButtonClicked = () => {
        btnClicked(SwitchButtonState.RIGHT)
    };

    const btnClicked = (state : SwitchButtonState) => {
        setActiveButton(state);
        onActiveChange(state)
    }

    useEffect(() => {
        if(props.active !== activeButton){
            setActiveButton(props.active)
        }
    }, [props.active])

    const {onActiveChange} = props;

    const wrapperClassNames = "button__switch switch-" + size;

    const isRightBtnActive = (
        (enableMiddleButton === false && activeButton !== SwitchButtonState.LEFT) || 
        (enableMiddleButton !== false && (activeButton !== SwitchButtonState.LEFT && activeButton !== SwitchButtonState.MIDDLE))
    )

    const isLeftBtnActive = activeButton === SwitchButtonState.LEFT;
    const isMiddleBtnActive = (activeButton !== SwitchButtonState.LEFT && activeButton !== SwitchButtonState.RIGHT);

    return (
        <div className={props.className ? wrapperClassNames + " " + props.className : wrapperClassNames}> 
            <button
                onClick={leftButtonClicked}
                type="button"
                className={`button-switch text-nowrap ${isLeftBtnActive ? 'active-left' : ''}`}>
                <span>{labelLeft}</span>
            </button>
            {(enableMiddleButton !== false) ?  
                <button
                    onClick={middleButtonClicked}
                    type="button"
                    className={`button-switch text-nowrap ${isMiddleBtnActive ? 'active-middle' : ''}`}>
                    <span>{labelMiddle}</span>
                </button> : ''
            }
            <button
                onClick={rightButtonClicked}
                type="button"
                className={`button-switch text-nowrap ${isRightBtnActive ? 'active-right' : ''}`}>
                <span>{labelRight}</span>
            </button>
        </div>
    );
}
